import * as Icons from 'lucide-react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { STRATEGIES } from '../../config/site';
import { SectionHeader } from '../common';

export default function StrategyEngineSection() {
  return (
    <section className="section">
      <div className="container-x">
        <div className="reveal"><SectionHeader eyebrow="Strategy Engine" title="Strategies built for different market conditions." sub="Five core strategy families, each tuned to how markets actually behave. Metrics below are historical / backtested and do not guarantee future results." /></div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {STRATEGIES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Cpu;
            return (
              <div key={s.name} className="panel panel-hover p-6 reveal reveal-card flex flex-col" style={{ transitionDelay: `${(i % 3) * 90}ms` }}>
                <div className="flex items-center justify-between mb-4">
                  <div className="w-11 h-11 rounded-xl flex items-center justify-center" style={{ background: 'var(--gold-soft)', border: '1px solid var(--gold-border)' }}><Icon size={20} className="text-[var(--gold-2)]" /></div>
                  <span className="chip">{s.risk} risk</span>
                </div>
                <h3 className="font-display text-[19px] font-bold text-white">{s.name}</h3>
                <p className="text-[13px] text-[var(--muted)] mt-1">{s.market} · {s.timeframe}</p>
                <div className="grid grid-cols-2 gap-x-4 gap-y-3 mt-5 font-mono text-[13px]">
                  <Metric label="Win rate" value={s.win} color="var(--emerald)" />
                  <Metric label="Profit factor" value={s.pf} />
                  <Metric label="Max DD" value={s.dd} color="var(--down)" />
                  <Metric label="Risk / reward" value={s.rr} color="var(--gold-2)" />
                </div>
              </div>
            );
          })}
          <div className="panel panel-hover p-6 reveal flex flex-col items-start justify-center" style={{ borderColor: 'var(--gold-border)', background: 'linear-gradient(180deg, rgba(214,179,106,0.06), var(--surface) 45%)' }}>
            <h3 className="font-display text-[19px] font-bold gold-text">Explore every strategy</h3>
            <p className="text-[14px] text-[var(--muted)] mt-2">Dive into logic, conditions and full backtest history for each family.</p>
            <Link to="/strategies" className="btn-gold inline-flex items-center gap-2 rounded-xl h-11 px-6 text-[14px] font-semibold mt-6">Explore Strategies <ArrowRight size={15} /></Link>
          </div>
        </div>
      </div>
    </section>
  );
}

function Metric({ label, value, color }) {
  return (
    <div>
      <div className="text-[10px] text-[var(--muted-2)] tracking-wide">{label.toUpperCase()}</div>
      <div className="text-[15px] font-semibold mt-0.5" style={{ color: color || 'var(--white)' }}>{value}</div>
    </div>
  );
}
